import React from 'react';
import styled from 'styled-components';

const Grid = styled.div`
  display: grid;
  gap: 2rem;
  margin-bottom: 3rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ContentGrid = ({ children, ...props }) => {
  return <Grid {...props}>{children}</Grid>;
};